import { render, staticRenderFns } from "./DoorCost.vue?vue&type=template&id=ffcd1b5a&"
import script from "./DoorCost.vue?vue&type=script&lang=js&"
export * from "./DoorCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports